<template>
  <transition
    name="drop-fade"
    appear
  >
    <slot
      name="content"
    />
  </transition>
</template>

<script>
export default {
  name: 'OwalTransitionDropFade',
}
</script>

<style scoped>
.drop-fade-enter-active {
  animation-name: drop-fade-in;
  animation-duration: 300ms;
  animation-timing-function: ease-in;
}

.drop-fade-leave-active, .drop-fade-leave-to {
  animation-name: drop-fade-out;
  animation-duration: 300ms;
  animation-timing-function: ease-out;
}

@keyframes drop-fade-in {
  0% {
    opacity: 0;
    height: 0;
    border-width: 0;
    border-color: none;
    transform: translateY(-0.25rem);
  }
  75% {
    transform: translateY(-0.05rem);
  }
  100% {
    opacity: 1;
    height: initial;
    border-width: 1px;
    border-color: initial;
  }
}

@keyframes drop-fade-out {
  0% {
    opacity: 1;
    height: initial;
    border-color: initial;
    border-width: 1px;
  }
  100% {
    opacity: 0;
    height: 0;
    border-width: 0px;
    border-color: none;
  }
}
</style>
